import { forwardRef } from 'react';
import type { Theme } from '../types';
import { SelectInput } from './SelectInput';
import { SelectOption } from './SelectOption';
import { CreateThemeButton } from './CreateThemeButton';

type Props = {
  /** Array of theme options to display */
  items: Theme[];
  /** Whether to show the create theme button */
  showCreateButton?: boolean;
  /** Callback when create theme button is clicked */
  onCreateClick?: () => void;
};

/**
 * Internal menu component that renders the dropdown with all theme options
 * This component is used by ThemeSelector and shouldn't be used directly
 */
const SelectMenuComponent = ({ items, showCreateButton, onCreateClick }: Props, ref: React.Ref<HTMLDivElement>) => {
  return (
    <SelectInput>
      <div ref={ref}>
        {items.map(x =>
          <SelectOption
            editable={x.editable}
            item={x}
            key={x.id} />)}
        {showCreateButton && onCreateClick && (
          <CreateThemeButton onClick={onCreateClick} />
        )}
      </div>
    </SelectInput>
  );
};

SelectMenuComponent.displayName = 'ChartTheming.SelectMenu';

export const SelectMenu = forwardRef(SelectMenuComponent);
